module.exports = __webpack_public_path__ + "img/bg_znzd.072f7f7c.png";